<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <h3>Список отчетов</h3>
            </v-flex>

            <v-flex xs12>

                <v-list
                >
                    <v-list-item
                            v-for="item in types"
                            :key="item.id"
                            link
                            @click="editItem(item)"
                    >
                        <!--                                <v-list-item-icon>-->
                        <!--                                    <v-icon>{{ item.icon }}</v-icon>-->
                        <!--                                </v-list-item-icon>-->

                        <v-list-item-content>
                            <v-list-item-title>{{ item.id }}. {{ item.report_name }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  data () {
    return {
    }
  },

  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    types () {
      return this.$store.getters['reportingReport/types']
    }
  },
  methods: {
    // initialize () {
    //   this.$store.dispatch('reportingList/fetchTypes')
    // },
    editItem (item) {
      this.$router.push({ name: 'reporting_list', params: { 'typeAbbr': item.abbr } })
    }
  }
}
</script>
<style scoped>
  td, th {
    text-align: left;
    padding: 5px;
  }
  th {
    vertical-align: top
  }
  .bloc_inline
  {
    display:inline-block;
  }
</style>
